import { useTranslation } from "react-i18next";
import requets from "../../../api";
import { useEffect, useState } from "react";
import { message } from "antd";
import moment from "moment";
import { defaultMeasurement } from "../components/default-value";
import { getURLServerEvent } from "../../../config.dev";
import { useAuth } from "react-oidc-context";

const loading = {
  LOADING: true,
  FINISHED: false,
};

export default function useMeasurement(devEui) {
  const auth = useAuth();
  const req = requets(auth.user.access_token);

  const { t } = useTranslation("global");
  const [messageSend, contextHolder] = message.useMessage();
  const [lastMeasurement, setLastMeasurement] = useState(defaultMeasurement);
  const [loadingMeasurement, setLoadingMeasurement] = useState(
    loading.FINISHED,
  );

  useEffect(() => {
    function fetchLastMeasurement() {
      setLastMeasurement(loading.LOADING);
      req
        .get(`/measurement/${devEui}/last`, {
          start: moment().subtract(1, "days").valueOf(),
          end: moment().valueOf(),
        })
        .then((response) => {
          if (response.status === 200) {
            setLastMeasurement(response.data);
          } else {
            setLastMeasurement(defaultMeasurement);
          }
        })
        .finally(() => setLoadingMeasurement(loading.FINISHED));
    }
    if (!devEui) return;
    fetchLastMeasurement();
    //startListeningEvent(devEui);
  }, [devEui]);

  return {
    loadingMeasurement,
    lastMeasurement,
  };
}
